module.exports = __webpack_public_path__ + "static/media/bus-icon-map.08475ce5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bus-icon-map.svg
// module id = 659
// module chunks = 0